import useAPI from '@/pages/members/hooks/useAPI';
import { InsuranceTypeRepository } from '@/repositories/members/InsuranceTypeRepository';

import { ONBOARDING_QUERY_KEY_PREFIX } from '../pages/Onboarding/components/Stepper';

export const useInsuranceTypes = ({ onboarding }: { onboarding: boolean }) => {
  const insuranceTypeRepository = InsuranceTypeRepository();

  return useAPI({
    queryKey: [ONBOARDING_QUERY_KEY_PREFIX, 'insuranceTypes', onboarding],
    queryFn: () => insuranceTypeRepository.list({ onboarding }),
    refetchOnWindowFocus: false
  });
};
